import styled from 'styled-components'
import {smallFont} from '../../../../../theme/font-styles'
import {CyberOwlTheme} from '../../../../../theme/theme'

interface TableDataRowProps {
    gridRow: number
    span?: number
}

export const TableDataRow = styled.div<TableDataRowProps>`
    grid-row: ${(props) => `${props.gridRow} / span ${props.span ?? 1}`};
    grid-column-start: 1;
    grid-column-end: -1;
    color: ${(props) => props.theme.reports.dataRow.text};
    background-color: ${(props) => props.theme.reports.dataRow.background};
    min-height: 64px;
    box-shadow: 1px 1px 6px -2px ${(props) => props.theme.reports.dataArea.boxShadow};
`

interface TableDataCellProps {
    gridRow: number
    gridColumn: number
    extrabold?: boolean
    centered?: boolean
}

function getFontWeight(theme: CyberOwlTheme, extraBold: boolean | undefined): number {
    return extraBold ? theme.font.weight.extrabold : theme.font.weight.normal
}

export const TableDataCell = styled.div<TableDataCellProps>`
    grid-row: ${(props) => props.gridRow};
    grid-column: ${(props) => props.gridColumn};
    margin-left: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-word;
    justify-content: flex-start;
    align-self: center;
    color: ${(props) => props.theme.colors.text.default};
    ${smallFont()}
    font-weight: ${(props) => getFontWeight(props.theme, props.extrabold)};
`

export const VesselNameWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
`

export const TooltipButton = styled.button`
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    line-height: 0;
`

export const TooltipIcon = styled.img`
    display: block;
`

export const TooltipContent = styled.div`
    background: #fff;
    position: absolute;
    color: #111;
    padding: 8px 10px;
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.06);
    z-index: 10;
    width: 300px;
    max-height: 500px;
    overflow-y: auto;
`

export const TooltipList = styled.ul`
    margin: 0;
    padding-left: 1.2rem;
`

export const TooltipListItem = styled.li`
    line-height: 1.4;
`
